import { observer } from 'mobx-react';
import React, { useMemo } from 'react';
import user from 'stores/user';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { theme } from 'theme';
import { createGlobalStyle } from 'styled-components'
import '../theme/fonts.css'

export const GlobalStyle = createGlobalStyle`
    * {
        box-sizing: border-box;
        font-family: 'Clear Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
            sans-serif !important;
    }

    html, body {
        margin: 0;
        padding: 0;
        font-family: 'Clear Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
            'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
            sans-serif !important;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
`

function ThemeProvider({ children }: { children: React.ReactNode }) {
    const darkMode = user.isDark;

    const themeObject = useMemo(() => theme(darkMode), [darkMode]);

    return (
        <StyledComponentsThemeProvider theme={themeObject}>
            <GlobalStyle />
            {children}
        </StyledComponentsThemeProvider>
    );
}

export default observer(ThemeProvider);
